/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { useLayout } from '../../core'
import { CustomTitle } from '../header/page-title/CustomTitle'

const Toolbar1: FC = () => {
  const { classes } = useLayout()

  return (
    <div className='toolbar' id='kt_toolbar'>
      {/* begin::Container */}
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
      >
        {/*<DefaultTitle />*/}
        <CustomTitle />
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Toolbar1 }
